export enum DaysOfWeek {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday',
}

export interface IDaysOfWeek {
  label: string;
  value: DaysOfWeek;
}

export const DaysOfWeekOptions: IDaysOfWeek[] = [
  {
    label: 'Monday',
    value: DaysOfWeek.MONDAY,
  },
  {
    label: 'Tuesday',
    value: DaysOfWeek.TUESDAY,
  },
  {
    label: 'Wednesday',
    value: DaysOfWeek.WEDNESDAY,
  },
  {
    label: 'Thursday',
    value: DaysOfWeek.THURSDAY,
  },
  {
    label: 'Friday',
    value: DaysOfWeek.FRIDAY,
  },
  {
    label: 'Saturday',
    value: DaysOfWeek.SATURDAY,
  },
  {
    label: 'Sunday',
    value: DaysOfWeek.SUNDAY,
  },
];
